import * as React from 'react';
import styled from 'styled-components';
import {
  color,
  ColorProps,
  compose,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';

export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M17.244 9.35l2.5-2.666a.997.997 0 000-1.372l-2.5-2.666a1 1 0 10-1.459 1.368L16.71 5H7.5c-1.324 0-2.566.654-3.456 1.545-.89.89-1.543 2.132-1.543 3.457l.001.991a1 1 0 002 0v-.991c0-.675.347-1.433.957-2.043.61-.61 1.368-.958 2.043-.96h9.204l-.92.983a1 1 0 101.458 1.368zm4.419 9.568c.352 0 .612.072.78.216.176.136.264.352.264.648 0 .304-.088.528-.264.672-.168.144-.428.216-.78.216h-4.38c-.288 0-.516-.084-.684-.252a.918.918 0 01-.252-.66c0-.344.136-.656.408-.936l2.544-2.652c.528-.552.792-1.06.792-1.524 0-.272-.08-.48-.24-.624-.152-.144-.372-.216-.66-.216a1.9 1.9 0 00-.648.108c-.192.064-.416.16-.672.288l-.24.12a4.335 4.335 0 00-.192.108 1.503 1.503 0 01-.24.108.716.716 0 01-.228.036.616.616 0 01-.504-.264 1.06 1.06 0 01-.204-.648c0-.176.024-.32.072-.432a.846.846 0 01.3-.312 4.697 4.697 0 011.26-.6 4.754 4.754 0 011.392-.216c.592 0 1.112.1 1.56.3.448.192.792.472 1.032.84.248.36.372.776.372 1.248 0 .488-.1.936-.3 1.344-.192.4-.524.848-.996 1.344l-1.704 1.74h2.412zm-8.634-1.916a1 1 0 110 2H6.907l.923.984a1 1 0 11-1.46 1.368l-2.498-2.666a.996.996 0 010-1.372L6.37 14.65a1 1 0 011.459 1.368l-.923.984h6.122z"
        clipRule="evenodd"
      />
    </svg>
  );
});
export const IconSystemV2MediaRepeat2Times = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
